<template>
	<div class="self-signup-success" data-testid="selfSignupSuccess">
		<v-icon size="80" color="black">mdi-email-outline</v-icon>
		<h1 class="mt-5 mb-4">Inscription réussie</h1>
		<p class="mb-2 text-center">Tu viens de recevoir un email à l'adresse suivante :</p>
		<p class="blue--text mb-6 text-center">{{ email }}</p>
		<p class="mb-6 text-center hint">Vérifie ta boîte mail pour démarrer ta formation.</p>
		<v-btn depressed large color="#15c39a" class="hvr-grow" :to="{ name: 'Login' }">
			<span class="white--text">Se connecter</span>
		</v-btn>
	</div>
</template>

<script>
export default {
	name: 'SelfSignupSuccess',
	props: {
		email: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.self-signup-success {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 50vh;
	padding: 24px;
	text-align: center;
}
.hint {
	max-width: 420px;
	color: #555;
}
</style>
